import React, { useEffect, useState } from 'react'
import GaleriaImagenes from '../components/GaleriaImagenes/GaleriaImagenes';
import Imagen from '../models/Imagen';
import { getImagenesEntorno } from '../services/EntornoService';

type Props = {}

const Entorno = (props: Props) => {

    var tituloSeccion: string = "Entorno";

    const [imagenes, setImagenes] = useState<Imagen[]>([]);

    useEffect(() => {
        setImagenes(getImagenesEntorno())
    }, []);

    return (
        
        <section className="page-section bg-primary text-white mb-0" id="entorno">

            <div className="container">

                <h2 className="page-section-heading text-center text-uppercase text-white">{ tituloSeccion }</h2>

                <div className="divider-custom divider-light">
                    <div className="divider-custom-line"></div>
                    <div className="divider-custom-icon">
                        <i className="fa-solid fa-tree"></i>
                    </div>
                    <div className="divider-custom-line"></div>
                </div>

                <div className="row">
                    <div className="col-lg-4 ms-auto">
                        <p className="lead textoJustificado">
                            El Albergue de Griegos está situado en Griegos (Teruel) a 1604 metros de altitud, concretamente en el pueblo más frío de España, a los pies de la Muela de San Juan.
                        </p>
                       
                    </div>
                    <div className="col-lg-4 me-auto">
                        <p className="lead textoJustificado">
                            Se trata de un lugar rodeado de fauna y naturaleza, donde podrás disfrutar de unas vistas espectaculares.
                        </p>
                    </div>
                </div>

                <div className='row'>
                    <div className="col-lg-8 me-auto ms-auto">
                        <p className="lead textoJustificado">
                            En el entorno se pueden hacer diversas rutas a caballo, rutas senderistas, MTB y rutas de de Trekking. También es idóneo para fotógrafos, amantes de las setas,  de las orquídeas y todo aquel que quiera escuchar la berrea.
                        </p>
                    </div>
                </div>

                <div className="divider-custom divider-light">
                    <div className="divider-custom-line divider-custom-line2"></div>
                </div>

                <div className='row mt-3 mb-3 contenedorFramesVideos'>
                    <iframe className='frameVideos' src="https://www.youtube.com/embed/8xN-ZJ8VOP0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    <iframe className='frameVideos mt-3' src="https://www.youtube.com/embed/fbAlV87wBOg" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    <iframe className='frameVideos mt-3' src="https://www.youtube.com/embed/AAt5_2GIvJM" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    <iframe className='frameVideos mt-3' src="https://www.youtube.com/embed/jnie8UDkQkI" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    <iframe className='frameVideos mt-3' src="https://www.youtube.com/embed/W71zpljhdZ8" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </div>

                <div className="divider-custom divider-light">
                    <div className="divider-custom-line divider-custom-line2"></div>
                </div>

                <div className='row'>
                    
                    <GaleriaImagenes imagenes={imagenes} nombreGaleria="Entorno" />

                </div>

            </div>

        </section>

    )
}

export default Entorno